import { Injectable, signal } from '@angular/core';
// import { CourseI } from '../courses/interfaces/course.interface';
// import { FilterCoursesI } from '../courses/interfaces/filter-courses.interface';
// import { FilterInstructorsI } from '../instructors/interfaces/filter-instructors.interface';
// import { InstructorI } from '../instructors/interfaces/instructor.interface';
// import { FilterProgramsI } from '../programs/interfaces/filter-programs.interface';
// import { ProgramI } from '../programs/interfaces/program.interface';
// import { FilterStudentsI } from '../students/interfaces/filter-students.interface';
// import { StudentI } from '../students/interfaces/student.interface';
import { FacultyI } from './interfaces/faculty.interface';
import { FilterFacultiesI } from './interfaces/filter-faculties.interface';
import { FilterProgramsI } from '../programs/interfaces/filter-programs.interface';
import { ProgramI } from '../programs/interfaces/program.interface';
import { CourseI } from '../courses/interfaces/course.interface';
import { FilterCoursesI } from '../courses/interfaces/filter-courses.interface';
import { FilterInstructorsI } from '../instructors/interfaces/filter-instructors.interface';
import { InstructorI } from '../instructors/interfaces/instructor.interface';
import { FilterStudentsI } from '../students/interfaces/filter-students.interface';
import { StudentI } from '../students/interfaces/student.interface';
import { FilterDepartmentsI } from '../departments/interfaces/filter-departments.interface';
import { DepartmentI } from '../departments/interfaces/department.interface';

@Injectable({
  providedIn: 'root',
})
export class FacultiesService {
  constructor() {}

  selectedFaculty = signal<FacultyI | null>(null);

  filterFaculties = signal<FilterFacultiesI | null>(null);

  updateFaculty = signal<FacultyI | null>(null);

  createFaculty = signal<FacultyI | null>(null);

  removeFaculty = signal<FacultyI | null>(null);
  // ********************************************* //
  filterDepartments = signal<FilterDepartmentsI | null>(null);

  updateDepartment = signal<DepartmentI | null>(null);

  createDepartment = signal<DepartmentI | null>(null);
  // ******************************************** ||

  filterPrograms = signal<FilterProgramsI | null>(null);

  updateProgram = signal<ProgramI | null>(null);

  createProgram = signal<ProgramI | null>(null);

  // ******************************************** ||

  filterCourses = signal<FilterCoursesI | null>(null);

  updateCourse = signal<CourseI | null>(null);

  createCourse = signal<CourseI | null>(null);

  // ******************************************** ||

  filterInstructors = signal<FilterInstructorsI | null>(null);

  updateInstructor = signal<InstructorI | null>(null);

  createInstructor = signal<InstructorI | null>(null);

  // ******************************************** ||

  filterStudents = signal<FilterStudentsI | null>(null);

  updateStudent = signal<StudentI | null>(null);

  createStudent = signal<StudentI | null>(null);
}
